import type { ReactNode } from 'react'

interface PromptTemplateDrawerHeaderProps {
  isEditing: boolean
}

/**
 * Header for the prompt template drawer showing contextual title and description.
 */
export const PromptTemplateDrawerHeader = ({
  isEditing,
}: PromptTemplateDrawerHeaderProps): ReactNode => (
  <div className="prompt-template-drawer-header flex flex-col gap-1 border-b px-6 py-4">
    <h2 className="prompt-template-drawer-title text-lg font-semibold">
      {isEditing ? 'Edit Prompt Template' : 'Create Prompt Template'}
    </h2>
    <p className="prompt-template-drawer-description text-sm text-muted-foreground">
      {isEditing
        ? 'Update the template name, description, and content.'
        : 'Define a reusable prompt template for your conversations.'}
    </p>
  </div>
)

PromptTemplateDrawerHeader.displayName = 'PromptTemplateDrawerHeader'
